import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button, Form } from "react-bootstrap";
import { saveGabarit } from "state/gabarit/actions";
import { toast } from "react-toastify";

/**
 * Sérialise l'état Redux orderEdition en données gabarit
 * Exclut les champs liés au devis/facture/paiement
 */
const serializeOrderEditionToGabarit = (orderEdition) => {
  const {
    // Champs exclus (devis, facture, paiement, ids techniques)
    groupedOrderId,
    groupedOrderUpdatedAt,
    groupedOrderStatus,
    status,
    isLoading,
    savInProgress,
    // Champs gardés
    ...gabaritData
  } = orderEdition;

  // Nettoie les orders: retire ids, statuts, et infos documents
  const cleanedOrders = (gabaritData.orders || []).map((order) => {
    const {
      id,
      status: orderStatus,
      info,
      googleCalendarEventId,
      ...orderData
    } = order;

    // Nettoie les items: retire les article_id
    const cleanedItems = (orderData.items || []).map((item) => {
      const { article_id, ...itemData } = item;
      return {
        ...itemData,
        products: item?.products
          ? item.products.map(({ id: _id, ...p }) => p)
          : undefined,
        product_parts: item?.product_parts
          ? item.product_parts.map(({ id: _id, ...pp }) => pp)
          : undefined,
      };
    });

    return {
      ...orderData,
      items: cleanedItems,
    };
  });

  return {
    ...gabaritData,
    orders: cleanedOrders,
  };
};

const SaveGabaritModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const orderEdition = useSelector((state) => state.orderEdition);
  const [name, setName] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    if (!name.trim()) return;

    setIsSaving(true);
    try {
      const data = serializeOrderEditionToGabarit(orderEdition);
      await dispatch(saveGabarit(name.trim(), data));
      toast.success(`Gabarit "${name.trim()}" enregistré`);
      setName("");
      onHide();
    } catch (err) {
      toast.error("Erreur lors de l'enregistrement du gabarit");
    } finally {
      setIsSaving(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && name.trim()) {
      handleSave();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Body style={{ padding: "24px" }}>
        <h5
          style={{
            fontWeight: "bold",
            marginBottom: "20px",
            textAlign: "center",
          }}
        >
          Enregistrement d'un gabarit
        </h5>

        <Form.Group>
          <Form.Label>Nom du gabarit</Form.Label>
          <Form.Control
            type="text"
            placeholder="Ex: HAO - Cocktail 50 pers"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
          />
        </Form.Group>

        <Button
          variant="success"
          onClick={handleSave}
          disabled={!name.trim() || isSaving}
          style={{
            width: "100%",
            marginTop: "16px",
            backgroundColor: "#579862",
            borderColor: "#579862",
          }}
        >
          {isSaving ? "Enregistrement..." : "Sauvegarder"}
        </Button>
      </Modal.Body>
    </Modal>
  );
};

export default SaveGabaritModal;
export { serializeOrderEditionToGabarit };
